// Chat Minimizado - Barra flutuante
import React from 'react';
import {
  XMarkIcon,
  ArrowsPointingOutIcon,
  Cog6ToothIcon
} from '@heroicons/react/24/outline';

interface ChatMinimizedProps {
  unreadCount: number;
  onExpand: () => void;
  onClose: () => void;
  onSettings: () => void;
}

const ChatMinimized: React.FC<ChatMinimizedProps> = ({
  unreadCount,
  onExpand,
  onClose,
  onSettings
}) => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg shadow-2xl flex items-center gap-2 p-2 pr-3">
        <button
          onClick={onExpand}
          className="flex items-center gap-1.5 hover:bg-white/10 rounded-lg p-1.5 transition-colors"
        >
          <div className="relative">
            <div className="text-lg">⚡</div>
            {unreadCount > 0 && (
              <div className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center animate-pulse">
                {unreadCount > 9 ? '9+' : unreadCount}
              </div>
            )}
          </div>
          <div>
            <div className="font-semibold text-sm">FlowChat</div>
            <div className="text-[10px] text-white/80">
              {unreadCount > 0 ? `${unreadCount} nova${unreadCount > 1 ? 's' : ''}` : 'Clique para abrir'}
            </div>
          </div>
        </button>

        <div className="flex items-center gap-0.5 border-l border-white/20 pl-1.5">
          <button
            onClick={onSettings}
            className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
            title="Configurações"
          >
            <Cog6ToothIcon className="h-4 w-4" />
          </button>
          
          <button
            onClick={onExpand}
            className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
            title="Expandir"
          >
            <ArrowsPointingOutIcon className="h-4 w-4" />
          </button>
          
          <button
            onClick={onClose}
            className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
            title="Fechar"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Pulse animation para nova mensagem */}
      {unreadCount > 0 && (
        <div className="absolute inset-0 bg-red-500 rounded-xl animate-ping opacity-20 pointer-events-none"></div>
      )}
    </div>
  );
};

export default ChatMinimized;
